<template>
  <div>
    <header class="main-header">
      <h2 class="h2-icon">Meine Merkliste</h2>
    </header>

    <div class="content">
      <svg
        width="264"
        height="264"
        viewBox="0 0 264 264"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M263.25 14.0063L249.994 0.75L0.75 249.994L14.0063 263.25L32.7563 244.5H225.75C230.721 244.493 235.485 242.515 239 239C242.515 235.485 244.493 230.721 244.5 225.75V32.7563L263.25 14.0063ZM225.75 225.75H51.5063L124.566 152.691L146.869 174.994C150.385 178.509 155.153 180.484 160.125 180.484C165.097 180.484 169.865 178.509 173.381 174.994L188.25 160.125L225.75 197.597V225.75ZM225.75 171.075L201.506 146.831C197.99 143.316 193.222 141.342 188.25 141.342C183.278 141.342 178.51 143.316 174.994 146.831L160.125 161.7L137.841 139.416L225.75 51.5063V171.075ZM38.25 188.25V160.125L85.125 113.278L97.9969 126.159L111.272 112.884L98.3812 99.9938C94.8651 96.4787 90.0968 94.504 85.125 94.504C80.1532 94.504 75.3849 96.4787 71.8688 99.9938L38.25 133.613V38.25H188.25V19.5H38.25C33.2787 19.505 28.5125 21.482 24.9972 24.9972C21.482 28.5125 19.505 33.2787 19.5 38.25V188.25H38.25Z"
          fill="black"
        />
      </svg>
      <span>Merkliste leer</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "WishlistView",
};
</script>

<style lang="scss" scoped>

.content {
    text-align: center;

    svg {
        width: 80%;
        max-width: 240px;
        height: auto;
        margin: 0 auto 15px;
        opacity: 0.15;
    }

    span {
        font-size: 1.2em;
        display: block;
    }
}
</style>
